import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Row, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as Utils from "../../Util/util";
import DataTable from "../../Components/DataTable";
import RequestStatus from "../../Components/RequestStatus";
import { getFranchiseEnquiries } from "../../Store/Actions/EnquiryActions";

const FranchiseDataTable = (props) => {
	const enquiryState = useSelector((state) => state.enquiry);

	const columns = [
		{
			dataField: "name",
			text: "Name",
			style: { textAlign: "center", paddingTop: "4px" },
			headerStyle: { textAlign: "center", paddingTop: "4px" },
		},
		{
			dataField: "email",
			text: "Email",
			style: { textAlign: "center", paddingTop: "4px" },
			headerStyle: { textAlign: "center", paddingTop: "4px" },
		},

		{
			dataField: "mobileNumber",
			text: "Mobile Number",
			headerStyle: { textAlign: "center" },
			style: { textAlign: "center" },
		},
		{
			dataField: "message",
			text: "Message",
			style: { textAlign: "center", paddingTop: "4px" },
			headerStyle: { textAlign: "center", paddingTop: "4px" },
		},
		{
			dataField: "createdAt",
			text: "Created Date",
			style: { textAlign: "center" },
			headerStyle: { textAlign: "center" },
			formatter: Utils.formatDateInTable,
		},
	];

	return (
		<div>
			<DataTable
				keyField="id"
				columns={columns}
				data={enquiryState.franchiseData ?? []}
				search={true}
				pagination={true}
				button={false}
				dialogButton={false}
				dialogAction={() => {}}
				buttonLabel=""
				className="transaction-table"
			/>
		</div>
	);
};

const ListFranchiseEnquiries = () => {
	const [alertStatus, setAlertStatus] = useState(true);

	const stateObject = useSelector((state) => state.enquiry);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getFranchiseEnquiries());
	}, [dispatch]);

	return (
		<>
			<Breadcrumb>
				<li className="breadcrumb-item">
					<Link to="/">Home</Link>
				</li>
				<Breadcrumb.Item active>Franchise Enquiries</Breadcrumb.Item>
			</Breadcrumb>
			<Card>
				<Card.Body>
					<Row>
						<Col md={12}>
							<FranchiseDataTable />
						</Col>
					</Row>
					<div className="text-center mt-5">
						<RequestStatus
							stateObj={stateObject}
							alertStatus={alertStatus}
							setAlertStatus={setAlertStatus}
						/>
					</div>
				</Card.Body>
			</Card>
		</>
	);
};

export default ListFranchiseEnquiries;
